import React, { useEffect, useState } from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://academiaholisticaargentina.com/cart/48929044562170:1';
function getSecondsUntilEndOfDay() {
  const now = new Date();
  const end = new Date(now);
  end.setHours(23, 59, 0, 0);
  const diff = Math.floor((end.getTime() - now.getTime()) / 1000);
  return diff > 0 ? diff : 0;
}
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilEndOfDay);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilEndOfDay());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="bg-[#f3e9f7] py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-[#e8d5f0]" data-id="element-293">
      <div className="container mx-auto max-w-3xl" data-id="element-294">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-295">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3d2a5f] mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-296">
            ⏰ PRECIO DE RELANZAMIENTO — CIERRA EN:
          </h2>

          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-297">
            <span className="bg-white border border-[#e8d5f0] text-[#3d2a5f] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold shadow-sm" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-298">
              {String(hours).padStart(2, '0')}
            </span>
            <span className="text-[#6b5a85] text-xl font-bold" data-id="element-299">hs</span>
            <span className="text-[#c9a14d] text-2xl font-bold animate-pulse" data-id="element-300">
              :
            </span>
            <span className="bg-white border border-[#e8d5f0] text-[#3d2a5f] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold shadow-sm" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-301">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-[#6b5a85] text-xl font-bold" data-id="element-302">min</span>
            <span className="text-[#c9a14d] text-2xl font-bold animate-pulse" data-id="element-303">
              :
            </span>
            <span className="bg-white border border-[#e8d5f0] text-[#3d2a5f] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold shadow-sm" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-304">
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="text-[#6b5a85] text-xl font-bold" data-id="element-305">seg</span>
          </div>

          <p className="text-red-500 font-bold text-lg mb-6" data-id="element-306">
            ⚠️ Después sube. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-white p-4 rounded-xl border border-[#e8d5f0] shadow-sm" data-id="element-307">
            <div className="flex justify-between text-xs font-bold mb-2" data-id="element-308">
              <span className="text-[#3d2a5f]" data-id="element-309">
                🔴 Cupos al precio de relanzamiento
              </span>
              <span className="text-[#c9a14d]" data-id="element-310">68%</span>
            </div>
            <div className="w-full bg-[#f3e9f7] rounded-full h-2.5" data-id="element-311">
              <div className="bg-gradient-to-r from-red-400 to-[#c9a14d] h-2.5 rounded-full" style={{
              width: '68%'
            }} data-id="element-312"></div>
            </div>
            <p className="text-[#6b5a85] text-[10px] mt-2 text-center" data-id="element-313">
              68% de los cupos ya tomados
            </p>
          </div>
        </div>

        <div ref={ref2} id="pricing-offer" style={{
        scrollMarginTop: '20px'
      }} className={`reveal max-w-xl mx-auto ${vis2 ? 'is-visible' : ''}`} data-id="element-314">
          {/* Single Product Card */}
          <div className="relative bg-white rounded-2xl p-6 sm:p-8 flex flex-col z-10 border-2 border-[#c9a14d] shadow-[0_20px_50px_rgba(61,42,95,0.1)]" data-id="element-315">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-316">
              <span className="bg-gradient-to-r from-[#c9a14d] to-[#b8945a] text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap uppercase tracking-wider" data-id="element-317">
                ⭐ OFERTA ÚNICA
              </span>
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-318">
              <h3 className="text-2xl sm:text-3xl font-bold text-[#3d2a5f] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-319">
                MEGAPACK MAESTRÍA REIKI
              </h3>
              <p className="text-[#c9a14d] font-bold text-sm sm:text-base" data-id="element-320">
                6 Tomos + 6 Bonos · Niveles I, II y Maestría
              </p>
            </div>

            <div className="bg-[#faf5fc] rounded-xl p-4 mb-6 border border-[#e8d5f0]" data-id="element-321">
              <ul className="space-y-3 text-sm text-[#3d2a5f] font-medium" data-id="element-322">
                <li className="flex items-center gap-2" data-id="element-323">
                  <CheckIcon className="w-5 h-5 text-[#c9a14d]" strokeWidth={3} data-id="element-324" />
                  Formación completa desde cero
                </li>
                <li className="flex items-center gap-2" data-id="element-325">
                  <CheckIcon className="w-5 h-5 text-[#c9a14d]" strokeWidth={3} data-id="element-326" />
                  Certificado oficial incluido
                </li>
                <li className="flex items-center gap-2" data-id="element-327">
                  <CheckIcon className="w-5 h-5 text-[#c9a14d]" strokeWidth={3} data-id="element-328" />
                  Acceso inmediato y de por vida
                </li>
                <li className="flex items-center gap-2" data-id="element-329">
                  <CheckIcon className="w-5 h-5 text-[#c9a14d]" strokeWidth={3} data-id="element-330" />
                  100% Online y a tu ritmo
                </li>
              </ul>
            </div>

            <div className="text-center mt-auto" data-id="element-331">
              <p className="text-[#6b5a85] text-sm line-through mb-1" data-id="element-332">
                $69.000
              </p>
              <p className="text-5xl sm:text-6xl font-extrabold text-[#3d2a5f] leading-none mb-6" data-id="element-333">
                $21.990{' '}
                <span className="text-xl font-bold text-[#6b5a85]" data-id="element-334">ARS</span>
              </p>

              <a href={CHECKOUT_BASE} target="_blank" rel="noopener noreferrer" className="w-full block py-4 md:py-5 rounded-xl text-white font-bold text-sm sm:text-base tracking-wider sm:tracking-widest uppercase text-center transition-all shadow-[0_10px_30px_rgba(201,161,77,0.4)] hover:shadow-[0_15px_40px_rgba(201,161,77,0.5)] hover:-translate-y-1 bg-gradient-to-r from-[#c9a14d] to-[#b8945a] border border-[#c9a14d]" style={{
              fontFamily: "'Inter', sans-serif",
              letterSpacing: '0.05em'
            }} data-id="element-335">
                → QUIERO MI MEGAPACK AHORA
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}